import React, { Component } from 'react';
import {observer} from 'mobx-react';
import * as mobx from 'mobx'
import store from '../store/downloaddata-store';
import { Form, Input, TextArea, Checkbox, Button } from 'semantic-ui-react'
import { Link } from "react-router-dom";
import eb from '../utils/EventBus';
import Select from 'react-select';
import axios from 'axios';
import {properties} from '../environments';

const BLOCK_CHAIN_URL = properties.BLOCKCHAIN_URL;


class DocDetail extends Component {

	constructor(props) {
    super(props);
    this.state={file: ''}
    this.handleUpload = this.handleUpload.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
		const { match } = this.props;
		store.loadDoc(match.params.id);
		store.getOrgEmail(); // to get userEmail and orgName to pass it to BC auth_user call
		store.selectedShUsers=null;
	    store.selectedRvwUsers=null;
	    store.selectedAppUsers=null;
	    store.loadShUsers();
	    store.loadRvwUsers();
	    store.loadAppUsers();
		eb.on('doc updated', () => this.props.history.push('/downloaddata'));
  }

  onChange = (e) => {
    this.setState({ file: e.target.files[0] });
  }

  upld=()=> {
    console.log('uploading');
    this.handleUpload();
  }

  handleUpload = async(req, res) => {


          const formData = new FormData();
          formData.append('file', this.state.file);

          let fileId = store.docid;
          console.log(fileId);

          // Get BC token
          const tokenData = await store.getBlockChainToken(store.username, store.orgname);;
          //console.log(tokenData.token);

          // BC upload call
          axios.post(`${BLOCK_CHAIN_URL}/api/v1/upload_file/${fileId}`, formData, { headers: { 'Authorization': `Bearer ${tokenData.token}` } })
            .then((result) => {
            if (result.data.success===true) {
            	// Insert into docdetail table
            	store.creDocDtl();
                eb.emit('toast', {
					status: 'success',
					text: 'Uploaded Successfully'
				})
            } else if (result.data.success===false) {
                  eb.emit('toast', {
					status: 'failed',
					text: 'Upload failed with error'
            	})
             }

            });
    }



  render() {
		const doc = store.selectedDoc;
		const newComment = store.newComment;

    return (
       <div className="buyer-invoice">
                <div className="title">
					<h4 align="left">Document Detail</h4>
				</div>
				{doc && (
					<Form>

						<Form.Field inline className="w-100" >
							<section className="left-float">

                            <label className="font-weight-600">Document Name</label>
							<Input className="w-100 mb-2"  readOnly value={doc.docname}/>

                            </section>
                                   <Button  className="right-float" primary onClick={store.dwnld}> Download Latest version </Button>

						</Form.Field>
						<Form.Field inline >
							<label>Document Description</label>
							<Input className="w-100"  readOnly value={doc.docdescr}/>
						</Form.Field>


						<Form.Field inline>
							<label>Creation Date</label>
							<Input className="w-100"  readOnly value={doc.creationdate}/>
						</Form.Field>

						<Form.Field inline>
							<label>Created By</label>
							<Input className="w-100"  readOnly value={doc.createdby}/>
						</Form.Field>

						<Form.Field inline>
							<label>Existing Comments</label>
							<TextArea  className="w-100" readonly value={doc.comments}/>
						</Form.Field>

						<Form.Field inline>
							<label>Enter new comment here</label>
							<TextArea  className="w-100" input type="text" value = {newComment} onChange={ (evt, { value }) => store.setNewComments(value)}/>
						</Form.Field>

						<Form.Field inline>
							<label>Tags</label>
							<TextArea  className="w-100" input type="text" value = {doc.tag} onChange={ (evt, { value }) => store.setTag(value)}/>
						</Form.Field>

						<Button   className="save" primary onClick={store.updDoc}>Save</Button>
<br/>
<br/>
                        <div>
				          <h5 align="center" className="line"></h5>
				        </div>

                        <br/>

						<div className="title">
				          <h4 align="left">Upload a new version</h4>
				        </div>

						<form onSubmit={this.handleUpload}>
				            <div>
				              <Form.Field inline>
				                <label>Select Document</label>
				                <input className="w-100" onChange={this.onChange} type="file" />
				              </Form.Field>
				            </div>

				        </form>

						<Form.Field inline>
			              <label>Share with user(s)</label>
			              <Select isMulti={true}
			                      value={store.selectedShUsers}
			                      onChange={(selectedShOption) => store.setSelectedShUsers(selectedShOption)}
			                      options={store.selectedShUsersOptions}
			                />
			            </Form.Field>

			            <Form.Field inline>
			              <label>Reviewer(s)</label>
			               <Select isMulti={true}
			                      value={store.selectedRvwUsers}
			                      onChange={(selectedRvwOption) => store.setSelectedRvwUsers(selectedRvwOption)}
			                      options={store.selectedRvwUsersOptions}
			                />
			            </Form.Field>

			            <Form.Field inline>
			              <label>Approver(s)</label>
			               <Select isMulti={true}
			                      value={store.selectedAppUsers}
			                      onChange={(selectedAppOption) => store.setSelectedAppUsers(selectedAppOption)}
			                      options={store.selectedAppUsersOptions}
			                />
			            </Form.Field>

			            <div>
				              <Button  className="save" primary onClick={this.upld}> Upload </Button>
				        </div>

					</Form>
				)}
				<div className="footer">

				</div>
		  </div>

    );
  }
}


export default observer(DocDetail);



// WEBPACK FOOTER //
// ./src/containers/DocDetail.js